import { render, staticRenderFns } from "./ActivityTabs.vue?vue&type=template&id=391c9232&scoped=true"
import script from "./ActivityTabs.vue?vue&type=script&lang=js"
export * from "./ActivityTabs.vue?vue&type=script&lang=js"
import style0 from "./ActivityTabs.vue?vue&type=style&index=0&id=391c9232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c9232",
  null
  
)

export default component.exports